import { createContext, useContext, useState, ReactNode } from "react";

type ModalContextType = {

  OpendProductDataModalId: string|null;
  setOpendProductDataModalId: React.Dispatch<React.SetStateAction<string|null>>
};

const ModalContext = createContext<ModalContextType | undefined>(undefined);

type ModalsProviderProps = {
  children: ReactNode;
};

function ModalsProvider({ children }: ModalsProviderProps) {
  const [OpendProductDataModalId, setOpendProductDataModalId] = useState<string|null>(null);

  return (
    <ModalContext.Provider
      value={{


        // opened Product data Modal Id
        OpendProductDataModalId,
        setOpendProductDataModalId
      }}
    >
      {children}
    </ModalContext.Provider>
  );
}

function useModals() {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error("useModals must be used within a ModalsProvider");
  }
  return context;
}

// eslint-disable-next-line react-refresh/only-export-components
export { ModalsProvider, useModals };
